import { ReviewState } from "../components/ProviderProfile/models";
import { ReviewState as PFPReviewState } from "../components/P4P/ProviderProfile/models";

    export function getReviewStateLabel(state: string):string {
        switch (state.toLowerCase()) {
            case ReviewState.COMPLETED.toLowerCase():
                case PFPReviewState.COMPLETED.toLowerCase():
                return 'Completed';
            case ReviewState.INPROGRESS.toLowerCase():
                case PFPReviewState.INPROGRESS.toLowerCase():
                return 'In Progress';
            case ReviewState.NOTSTART.toLowerCase():
                case PFPReviewState.NOTSTART.toLowerCase():
                return 'Not Started';
            default:
                return state;
        }
    };